/* eslint-disable no-param-reassign */
export const availableDeviceTypes = new Set(['A6:N1', 'A6:N2', 'A5:N2']);
export const getCDMAPreferred = (details: any, availableDeviceTypes: Set<string>): boolean => {
  try {
    const isCDMAPreferred = availableDeviceTypes.has(details?.data?.device?.deviceType) &&
      details?.data?.device?.radios[0]?.radioComponents ?
      details?.data?.device?.radios[0]?.radioComponents[0]?.CDMAPreferred :
      details?.data?.device?.radioComponents[0]?.CDMAPreferred;
    return isCDMAPreferred;
  } catch (error) {
    return false;
  }
}
/* eslint arrow-body-style: ["error", "always"] */
const fetchRadioSerailNumber = (radio: any) => {
  return radio?.radios[0]?.deviceSerialNumber
}

const assignRadios = (display: any, radio: any) => {
  if (availableDeviceTypes.has(radio.deviceType) && radio.radios?.[0]?.radioComponents) {
    radio.radios[0].radioComponents.forEach((component: any) => {
      if (component.communicationMethod === 'Cellular') {
        display.radio.cellRadio = {
          radioType: radio.radioType,
          deviceSerialNumber: fetchRadioSerailNumber(radio),
          port: component.port,
          IMEI: component.IMEI,
          MEID: component.MEID,
          ICCID: component.ICCID,
          IMSI: component.IMSI,
          MDN: component.MDN,
          ESN: component.ESN,
          softwarePartNumber: radio.softwarePartNumber,
          hardwarePartNumber: radio.hardwarePartNumber,
          updatedTime: radio.updatedTime,
          deviceId: radio.deviceId,
        };
      }
      if (component.communicationMethod === 'Satellite') {
        display.radio.satRadio = {
          IMEI: component.IMEI,
          MSISDN: component.MSISDN,
          ICCID: component.ICCID,
          radioType: radio.radioType,
          deviceSerialNumber: fetchRadioSerailNumber(radio),
          port: component.port,
          softwarePartNumber: radio.softwarePartNumber,
          hardwarePartNumber: radio.hardwarePartNumber,
          deviceId: radio.deviceId,
        };
      }
      if (!component.communicationMethod) {
        if (component.componentType === '1' || radio.radios[0].radioComponents.length === 1) {
          display.radio.satRadio = {
            communicationMethod: "Satellite",
            IMEI: component.IMEI,
            MSISDN: component.MSISDN,
            ICCID: component.ICCID,
            radioType: radio.radioType,
            deviceSerialNumber: fetchRadioSerailNumber(radio),
            port: component.port,
            softwarePartNumber: radio.softwarePartNumber,
            hardwarePartNumber: radio.hardwarePartNumber,
            deviceId: radio.deviceId,
          };
        }

        if (component.componentType === '2' || radio.radios[0].radioComponents.length === 1) {
          display.radio.cellRadio = {
            communicationMethod: "Cellular",
            IMEI: component.IMEI,
            MEID: component.MEID,
            ICCID: component.ICCID,
            IMSI: component.IMSI,
            MDN: component.MDN,
            ESN: component.ESN,
            radioType: radio.radioType,
            deviceSerialNumber: fetchRadioSerailNumber(radio),
            port: component.port,
            softwarePartNumber: radio.softwarePartNumber,
            hardwarePartNumber: radio.hardwarePartNumber,
            updatedTime: radio.updatedTime,
            deviceId: radio.deviceId,
          };
        }
      }
    });
  }
  else if (radio.radioComponents) {
    radio.radioComponents.forEach((component: any) => {
      if (component.communicationMethod === 'Cellular') {
        display.radio.cellRadio = {
          radioType: radio.radioType,
          deviceSerialNumber: radio.deviceSerialNumber,
          port: component.port,
          IMEI: component.IMEI,
          MEID: component.MEID,
          ICCID: component.ICCID,
          IMSI: component.IMSI,
          MDN: component.MDN,
          isCDMAPreferred: component.CDMAPreferred,
          ESN: component.ESN,
          softwarePartNumber: radio.softwarePartNumber,
          hardwarePartNumber: radio.hardwarePartNumber,
          updatedTime: radio.updatedTime,
          deviceId: radio.deviceId,
        };
      }
      if (component.communicationMethod === 'Satellite') {
        display.radio.satRadio = {
          IMEI: component.IMEI,
          MSISDN: component.MSISDN,
          ICCID: component.ICCID,
          radioType: radio.radioType,
          deviceSerialNumber: radio.deviceSerialNumber,
          port: component.port,
          softwarePartNumber: radio.softwarePartNumber,
          hardwarePartNumber: radio.hardwarePartNumber,
          deviceId: radio.deviceId,
        };
      }
      if (!component.communicationMethod) {
        if (component.componentType === '1' || radio.radioComponents.length === 1) {
          display.radio.satRadio = {
            communicationMethod: "Satellite",
            IMEI: component.IMEI,
            MSISDN: component.MSISDN,
            ICCID: component.ICCID,
            radioType: radio.radioType,
            deviceSerialNumber: radio.deviceSerialNumber,
            port: component.port,
            softwarePartNumber: radio.softwarePartNumber,
            hardwarePartNumber: radio.hardwarePartNumber,
            deviceId: radio.deviceId,
          };
        }
        if (component.componentType === '2' || radio.radioComponents.length === 1) {
          display.radio.cellRadio = {
            communicationMethod: "Cellular",
            IMEI: component.IMEI,
            MEID: component.MEID,
            ICCID: component.ICCID,
            IMSI: component.IMSI,
            MDN: component.MDN,
            isCDMAPreferred: component.CDMAPreferred,
            ESN: component.ESN,
            radioType: radio.radioType,
            deviceSerialNumber: radio.deviceSerialNumber,
            port: component.port,
            softwarePartNumber: radio.softwarePartNumber,
            hardwarePartNumber: radio.hardwarePartNumber,
            updatedTime: radio.updatedTime,
            deviceId: radio.deviceId,
          };
        }
      }
    });
  }
};

export const formatDeviceDetails = (details: any) => {
  if (details && details.data) {
    const display = {
      deviceId: details.data.device?.deviceId || '',
      deviceType: details.data.device?.deviceType || '',
      deviceStatus: details.data.device ? details.data.device.deviceStatus === 'disabled' : false,
      // eslint-disable-next-line no-unneeded-ternary
      isSwapsEnabled: (details.data.device?.isSwapsEnabled === false) ? "false" : details.data.device?.isSwapsEnabled,
      isRadioDropEnabled: (details.data.device?.isRadioDropEnabled === false) ? "false" : details.data.device?.isRadioDropEnabled,
      createdTime: details.data.device?.createdTime || '',
      lastUpdatedBy: details.data.device?.lastUpdatedBy || '',
      lastDisabledBy: details.data.device?.lastDisabledBy || '',
      detailedDeviceType: details.data.device?.detailedDeviceType || '',
      assetMake: details.data.asset?.assetMake || '',
      assetSerialNumber: details.data.asset?.assetSerialNumber || '',
      deviceSerialNumber: details.data?.device?.deviceSerialNumber || '',
      softwarePartNumber: details.data?.device?.softwarePartNumber || '',
      isCDMAPreferred: getCDMAPreferred(details, availableDeviceTypes),
      radio: {
        cellRadio: {},
        satRadio: {},
      },
    };
    if (details.data.device?.radioComponents) {
      assignRadios(display, details.data.device);
    }
    if (
      Object.keys(display.radio.cellRadio).length === 0 &&
      Object.keys(display.radio.satRadio).length === 0 &&
      details.data.device?.radios
    ) {
      details.data.device.radios.forEach((radio: any) => {
        assignRadios(display, radio);
      });
    }
    if ((details.data.device.radios === null) && (details.data.device.radioComponents === null || details.data.device?.radioComponents.length === 0)) {
      let isCDMAPreferred = false;
      try {
        isCDMAPreferred = (details.data.device.radioComponents[0]?.CDMAPreferred === true) ? "true" : details.data.device.radioComponents[0]?.CDMAPreferred;
      } catch (error) {
        isCDMAPreferred = false;
      }
      display.radio.cellRadio = {
        communicationMethod: "Cellular",
        componentType: "2",
        radioType: details.data.device?.radioType,
        deviceSerialNumber: details.data.device?.deviceSerialNumber,
        port: "",
        IMEI: "",
        MEID: "",
        softwarePartNumber: "",
        hardwarePartNumber: "",
        updatedTime: details.data.device?.updatedTime,
        ICCID: "",
        IMSI: "",
        MDN: "",
        ESN: "",
        isCDMAPreferred,
        deviceId: details.data.device?.deviceId,
      };
      display.radio.satRadio = {
        communicationMethod: "Satellite",
        componentType: "1",
        radioType: details.data.device?.radioType,
        deviceSerialNumber: details.data.device?.deviceSerialNumber,
        port: "",
        IMEI: "",
        MSISDN: "",
        softwarePartNumber: "",
        hardwarePartNumber: "",
        ICCID: "",
        deviceId: details.data.device?.deviceId,
      };
    }
    return display;
  }
  return {};
};